﻿window.dialog = function () {

    var dialog_title;
    var dialog_message;
    var dialog_buttonTextYes;
    var dialog_buttonTextNo;

    return {

        /**
         * Init dialog screen (will be done after the init for the)
         * @param {String} title
         * @param {String} message
         * @param {String} buttonTextYes
         * @param {String} buttonTextNo
         */
        initialize: function (title, message, buttonTextYes, buttonTextNo) {
            dialog_title = title;
            dialog_message = message;
            dialog_buttonTextYes = buttonTextYes;
            dialog_buttonTextNo = buttonTextNo;
        },

        /**
         * Create dialog
         * @param {Function} callbackYes
         * @param {Function} callbackNo
         */
        createDialog: function (callbackYes, callbackNo) {
            form.createDialog(dialog_title, dialog_message, dialog_buttonTextYes, callbackYes, dialog_buttonTextNo, callbackNo);
        },

        /**
         * Create dialog
         * @param {String} title
         * @param {String} message
         * @param {Function} callbackYes
         * @param {Function} callbackNo
         */
        createDialogWithCustomTitleAndMessage: function (title, message, callbackYes, callbackNo) {
            form.createDialog(title, message, dialog_buttonTextYes, callbackYes, dialog_buttonTextNo, callbackNo);
        },

        closeDialog: function () {
            form.closeDialog();
        }
    }
}();